import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  @media(max-width: 991px) {
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
  }
`;